import {
  Box,
  Button,
  FormControl,
  Grid,
  TextField,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Paper,
  Slider,
  Modal,
  IconButton,
  FormLabel,
  CircularProgress,
  Switch

} from "@mui/material";
import * as faceapi from "face-api.js";
import React, { useRef } from "react";
import { useState } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonDatePicker from "../../Base/views/CommonDatePicker";
import { AddEmailTokenHelper } from "../../Ancillary/EmailToken/helper/EmailTokenHelper";
import {
  checkPayrollAccess,
  convertBase64,
  getUserData,
  loadFaceApiModels,
  s3Client,
} from "../../Base/helper/baseFunctions";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { useDropzone } from "react-dropzone";
import DeleteIcon from "@mui/icons-material/Delete";
import SelectableSearch from "../../Base/views/SelectableSearch";
import { GetDesignationAction } from "../../../../store/Ancillary/Designation/Action";
import { GetWorkLocationAction } from "../../../../store/Ancillary/WorkLocation/Action";
import { GetEmployeesAction } from "../../../../store/Employee/Employee/Action";
import Popup from "../../Base/views/Popup";
import Success from "../Image/check.png";
import {
  AddEmployeeHelper,
  addUserHelper,
  GetReportingManagersHelper,
  UpdateEmployeePopupHelper,
} from "../../Employee/helper/EmployeeHelper";
import { validateEmailHelper } from "../../SignIn/helper/SigninHelper";
import CreatableSearch from "../../Base/views/CreatableSearch";
import { AddDesignationHelper } from "../../Ancillary/Designation/helper/DesignationHelper";
import { AddWorkLocationHelper } from "../../Ancillary/WorkLocation/helper/WorkLocation";
import PayrollSetupPopup from "../../Finance/views/Employee/PayrollSetupPopup";
import { GetBusinessUnitAction } from "../../../../store/Ancillary/BusinessUnit/Action";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import CloseIcon from "@mui/icons-material/Close";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { GetEmpIDContractualHelper, GetEmpIDHelper } from "../../Ancillary/CompanyDetails/helper/CompanyDetailsHelper";
import Note from "../Image/alert.png";
import EmployeeID from "../../AdminSettings/views/Employee/EmployeeID";
import { GetHomeAction } from "../../../../store/EmployeeDashboard/Action";
import { generateEmbeddingsControllerHelper } from "../../FaceAttendance/helper/FaceRecognizationHelper";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { GetContractorHelper } from "../../Ancillary/Contractor/helper/ContractorHelper";

const AddEmployeePopup = ({ setOpenPopup, email, editRecord, inactive }) => {
  const useStyles = makeStyles((theme) =>
    createStyles({
      paper: {
        boxShadow:
          theme.palette.mode === "dark"
            ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
            : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "20px",
        borderRadius: "10px",
      },
      comingSoon: {
        fontWeight: 600,
        fontSize: "18px",
        marginTop: "30px",
        color: "white",
      },
    })
  );
  const classes = useStyles();
  const dispatch = useDispatch();
  let userData = getUserData();
  const date = new Date();
  const default_date = `${date?.getFullYear() +
    "-" +
    ("0" + (date?.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + date?.getDate()).slice(-2)
    }`;
  const initialFValues = {
    previous_employee_id: "",
    first_name: "",
    last_name: "",
    dob: null,
    isactive: true,
    _designation_id: "",
    office_email: email || "",
    ats_work_location_id: "",
    reportingmanager_id: "",
    core_hr_user_type: "Employee",
    enable_corehr: true,
    enable_ats: false,
    joining_date: default_date,
    image: "",
    businessUnit: "",
    uan_no: "",
    pan: "",
    title: "Mr",
    work_hour_configuration_id: "",
    whatsapp_phone_no: "",
    enable_payroll: false,
    enable_payroll_executive: false,
    enable_finance_executive: false,
    enable_visitor_management: false,
    enable_expense_executive: false,
    enable_lms_executive: false,
    vm_exec_access: false,
    custom_empno_flag: false,
    custom_empno_value: "",
    enable_settings_access: false,
    enable_employee_management: false,
    enable_lms: true,
    create_user: true,
    contractor_id: ""
  };
  const [currentData, setCurrentData] = useState("");
  const [errors, setErrors] = useState({});
  const [imgfiles, setimgFiles] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [employeeModalData, setEmployeeModalData] = useState(initialFValues);
  const [successPopup, setSuccessPopup] = useState(false);
  const [payroll, setPayroll] = useState(false);
  const [image, setImage] = useState(null);
  const [rotation, setRotation] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const cropperRef = useRef(null);
  const [warning, setWarning] = useState(false);
  const [empno, setEmpNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [imageValidation, setImageValidation] = useState(false);
  const [actionLoader, setActionLoader] = useState(false);
  const [designationData, setDesignationData] = useState({
    load: false,
    values: [],
  });
  const [worklocationData, setWorklocationData] = useState({
    load: false,
    values: [],
  });
 
  const [step, setStep] = useState(1);
  const { designation_options } = useSelector(
    (state) => state?.AncillaryReducer?.DesignationReducer
  );
  const { workLocation_options } = useSelector(
    (state) => state?.AncillaryReducer?.WorkLocationReducer
  );
  const { atsModuleData } = useSelector(
    (state) => state?.RoleAndAccessReducer?.ATSModuleReducer
  );
  const leaveAccess = atsModuleData?.find((item) => item.module_name === "Leave");
  const whatsAppFlow = atsModuleData?.find((item) => item.module_name === "Whatsapp Flow");

  const { businessunitData } = useSelector(
    (state) => state.AncillaryReducer?.BusinessUnitReducer
  );
  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });
  const [businessUnitData, setBusinessUnitData] = useState({
    load: true,
    values: [],
  });
  const [contractorOptions, setContractorOptions] = useState({
    load: true,
    values: [],
  });
  useEffect(() => {
    const loadModels = async () => {
      try {
        await loadFaceApiModels();
      } catch (err) {
        console.error("Error loading face-api models:", err);
      }
    };

    loadModels();
  }, []);
  const EmployeeIdConfigCheck = async () => {
    try {
      const [fullTimeRes, contractualRes] = await Promise.all([
        GetEmpIDHelper(),
        GetEmpIDContractualHelper(),
      ]);

      const fullTimeExists = fullTimeRes?.data?.data?.length > 0;
      const contractualExists = contractualRes?.data?.data?.length > 0;

      if (fullTimeExists && contractualExists) {
        setEmpNo({
          fullTime: fullTimeRes.data.data[0],
          contractual: contractualRes.data.data[0],
        });
      } else {
        setEmpNo(null);
      }
    } catch (error) {
      setEmpNo(null);
    }
  };
  useEffect(() => {
    dispatch(GetDesignationAction());
    dispatch(GetWorkLocationAction());
    dispatch(GetBusinessUnitAction());
    handleContractorOptionLoad();
    handleEmployees();
    EmployeeIdConfigCheck();
   
    if (editRecord?.employee_id) {
      setEmployeeModalData({
        ...editRecord,
        dob: editRecord?.date_of_birth,
        joining_date: editRecord?.doj,
        _designation_id: editRecord?.designation_id
          ? {
            designation_id: editRecord?.designation_id,
            name: editRecord?.designation,
          }
          : "",
        ats_work_location_id: editRecord?.wl_id
          ? {
            ats_work_location_id: editRecord?.wl_id,
            work_location_name: editRecord?.work_location,
          }
          : "",
        reportingmanager_id: editRecord?.reporting_manager_id
          ? {
            employee_id: editRecord?.reporting_manager_id,
            name: editRecord?.reporting_manager,
          }
          : "",
        businessUnit: editRecord?.businessunit
          ? {
            businessUnit: editRecord?.businessunit_fk,
            name: editRecord?.businessunit,
          }
          : "",
        work_hour_configuration_id: editRecord?.work_hour_configuration_id
          ? {
            work_hour_configuration_id: editRecord?.work_hour_configuration_id,
            work_hour_code: editRecord?.work_hour_code,
          }
          : "",
          custom_empno_value: editRecord?.employee_no,
          contractor_id: editRecord?.contractor_id
          ? {
            contractor_id: editRecord?.contractor_id,
            name: editRecord?.contractor_name,
          }
          : "",
      });
      editRecord?.image && getImageSignedUrl(editRecord);
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    editRecord,
  ]);
  useEffect(() => {
     if (!editRecord?.employee_id) {
      const defaultWorkLocation = workLocation_options?.find(loc => loc?.is_default);
      setEmployeeModalData({
        ...employeeModalData,
        ats_work_location_id: defaultWorkLocation ? defaultWorkLocation : "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[workLocation_options])
  const getImageSignedUrl = async (currentData) => {
    let filename = currentData?.image;
    const bucketParams = {
      Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
      Key: filename,
    };
    try {
      const url = await getSignedUrl(
        s3Client,
        new GetObjectCommand(bucketParams),
        { expiresIn: 3 * 60 }
      ); // Adjustable expiration.
      setImageUrl(url);
      return url;
    } catch (err) {
      toast.error(err);
    }
  };
  const validate = (fieldValues) => {
    let temp = { ...errors };
    if ("first_name" in fieldValues) {
      temp.first_name =
        fieldValues.first_name?.trim() === "" ? "First Name is required" : "";
    }
    if ("last_name" in fieldValues) {
      temp.last_name =
        fieldValues.last_name?.trim() === "" ? "Last Name is required" : "";
    }
    if ("whatsapp_phone_no" in fieldValues) {
      temp.whatsapp_phone_no =
        !fieldValues.whatsapp_phone_no?.trim() && whatsAppFlow
          ? "Mobile Number is required"
          :  fieldValues.whatsapp_phone_no && !/^\d{10}$/.test(fieldValues.whatsapp_phone_no)
            ? "Invalid Mobile Number."
            : "";
    }
    if ("phone" in fieldValues) {
      temp.phone =
        fieldValues.phone === "" || fieldValues.phone === null
          ? "Mobile No is required"
          : fieldValues?.phone.toString() !== "" &&
            !fieldValues?.phone
              ?.toString()
              ?.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)
            ? "Invalid Mobile Number."
            : "";
    }
    if ("office_email" in fieldValues) {
      temp.office_email =
        fieldValues?.office_email?.trim() === "" || fieldValues?.office_email === null
          ? "Email is required"
          : /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
            fieldValues.office_email
          )
            ? ""
            : "Invalid Email.";
    }
    if ("_designation_id" in fieldValues) {
      temp._designation_id =
        fieldValues._designation_id === "" || null
          ? "Designation is required"
          : "";
    }
    if ("ats_work_location_id" in fieldValues) {
      temp.ats_work_location_id =
        fieldValues.ats_work_location_id === "" || null
          ? "Work Location is required"
          : "";
    }
    // if ("work_hour_configuration_id" in fieldValues) {
    //   temp.work_hour_configuration_id =
    //     fieldValues.work_hour_configuration_id === "" || null
    //       ? "Work Hour"
    //       : "";
    // }
    if ("reportingmanager_id" in fieldValues) {
      temp.reportingmanager_id =
        fieldValues.reportingmanager_id === "" || null
          ? "Reporting Manager is required"
          : "";
    }
    if ("joining_date" in fieldValues) {
      temp.joining_date =
        fieldValues.joining_date === "" || fieldValues.joining_date === null
          ? "Date of Joining is required"
          : "";
    }
    // if ("uan_no" in fieldValues) {
    //   temp.uan_no =
    //     fieldValues.uan_no === "" || fieldValues.uan_no === null
    //       ? ""
    //       : fieldValues?.uan_no.toString() !== "" &&
    //         !fieldValues?.uan_no?.toString()?.match(/^\(?[0-9]{12}$/)
    //         ? "Invalid UAN Number."
    //         : "";
    // }
    // if ("pan" in fieldValues) {
    //   temp.pan =
    //     fieldValues.pan === "" || fieldValues.pan === null
    //       ? ""
    //       : fieldValues?.pan.toString() !== "" &&
    //         !fieldValues?.pan
    //           ?.toString()
    //           ?.match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)
    //         ? "Invalid PAN Number."
    //         : "";
    // }
    if ("enable_payroll" in fieldValues) {
      temp.enable_payroll = fieldValues.enable_payroll &&
      !employeeModalData?.enable_payroll_executive &&
      !employeeModalData?.enable_finance_executive
        ? "Please select at least one executive type"
        : "";;
    }
    if ("custom_empno_value" in fieldValues && employeeModalData?.custom_empno_flag) {
      temp.custom_empno_value =
        !fieldValues.custom_empno_value?.trim() ? "Employee number is required" : "";
    }
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };
  const handleEmployees = () => {
    GetReportingManagersHelper({ domain: userData?.domain }).then((res) => {
      if(res?.data?.statuscode === 200) {
        const emp_options = res?.data?.data
        setEmployeesData({ load: false, values: emp_options });
      } else {
        setEmployeesData({ load: false, values: [] });
      }
    })
  };
  const handleContractorOptionLoad = () => {
    GetContractorHelper({ domain: userData?.domain }).then((res) => {
      if(res?.data?.statuscode === 200) {
        const res_options = (res?.data?.data || [])?.filter(el => el?.status === "Active")
        setContractorOptions({ load: false, values: res_options });
      } else {
        setContractorOptions({ load: false, values: [] });
      }
    })
  };
  const handleInputChange = (event, value) => {
    if (["reportingmanager_id", "work_hour_configuration_id", "contractor_id"].includes(event)) {
      if (value) {
        setEmployeeModalData({ ...employeeModalData, [event]: value });
      } else {
        setEmployeeModalData({ ...employeeModalData, [event]: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...employeeModalData, [event]: value ? value : "" });
    } else if (["_designation_id"].includes(event)) {
      if (value?.id === null) {
        AddDesignationHelper({ name: value?.name }).then((res) => {
          setDesignationData({ load: false, values: res?.data?.data });
          setEmployeeModalData({
            ...employeeModalData,
            [event]: res?.data?.data?.filter(
              (resp) => resp?.name === value?.name
            )?.[0],
          });
        });
      } else setEmployeeModalData({ ...employeeModalData, [event]: value });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...employeeModalData, [event]: value ? value : "" });
    } else if (["ats_work_location_id"].includes(event)) {
      if (value?.id === null) {
        AddWorkLocationHelper({ name: value?.work_location_name }).then(
          (res) => {
            setWorklocationData({ load: false, values: res?.data?.data });
            setEmployeeModalData({
              ...employeeModalData,
              [event]: res?.data?.data?.filter(
                (resp) => resp?.work_location_name === value?.work_location_name
              )?.[0],
            });
          }
        );
      } else setEmployeeModalData({ ...employeeModalData, [event]: value });

      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...employeeModalData, [event]: value ? value : "" });
    } else if (event === "businessUnit") {
      if (value) {
        setEmployeeModalData({ ...employeeModalData, [event]: value });
      } else {
        setEmployeeModalData({ ...employeeModalData, [event]: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...employeeModalData, [event]: value ? value : "" });
    } else if (event?.target?.name === "core_hr_user_type") {
      setEmployeeModalData({
        ...employeeModalData,
        [event?.target?.name]: event?.target?.value,
        enable_expense_executive: event?.target?.value === "Admin" ? true : false,
        enable_settings_access: event?.target?.value === "Admin" ? true : false,
        enable_employee_management: event?.target?.value === "Admin" ? true : false,
        enable_lms: event?.target?.value === "Admin" ? true : false,
        enable_lms_executive: false,
        enable_payroll: false,
        enable_payroll_executive: false,
        enable_finance_executive: false,
        vm_exec_access: false
      });
    } else if (["create_user"].includes(event?.target?.name)) {
      const createUser = event?.target?.checked;
      setEmployeeModalData({
        ...employeeModalData,
        [event.target.name]: event.target.checked,
        ...(createUser ? {
          enable_corehr: true,
          enable_lms: true,
        } : {
          enable_corehr: false,
          enable_lms: false,
        }),
        enable_ats: false,
        enable_payroll: false,
        enable_payroll_executive: false,
        enable_finance_executive: false,
        enable_visitor_management: false,
        enable_expense_executive: false,
        enable_lms_executive: false,
        enable_settings_access: false,
        enable_employee_management: false,
        vm_exec_access: false
      });
    } else if (["enable_ats", "enable_visitor_management", "enable_expense_executive", "enable_lms_executive",
      "enable_settings_access", "enable_employee_management", "enable_lms", "vm_exec_access"
    ].includes(event?.target?.name)) {
      const isLMS = event?.target?.name === "enable_lms";
      const isVisitorMg = event?.target?.name === "enable_visitor_management";
      setEmployeeModalData({
        ...employeeModalData,
        [event.target.name]: event.target.checked,
        ...(isLMS && {enable_lms_executive: false}),
        ...(isVisitorMg && {vm_exec_access: false})
      });
    } else if (["custom_empno_flag"].includes(event?.target?.name)) {
      setEmployeeModalData({
        ...employeeModalData,
        [event.target.name]: event.target.checked,
         ...(event.target.checked === false && {
          custom_empno_value: editRecord?.employee_no || "",
        }),
        
      });
    } else if (["enable_payroll"].includes(event?.target?.name)) {
      setEmployeeModalData({
        ...employeeModalData,
        [event.target.name]: event.target.checked,
        enable_payroll_executive: false,
        enable_finance_executive: false
      });
      if (errors?.enable_payroll) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          enable_payroll: "",
        }));
      }
    } else if (["enable_payroll_executive","enable_finance_executive"].includes(event?.target?.name)) {
      setEmployeeModalData({
        ...employeeModalData,
        [event.target.name]: event.target.checked,
      });
      if (errors?.enable_payroll) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          enable_payroll: "",
        }));
      }
    } else if (event?.target?.value === "Admin") {
      setEmployeeModalData({
        ...employeeModalData,
        [event?.target?.name]: event?.target?.value,
        enable_ats: userData?.enable_ats? true : false,
      });
    } else {
      setEmployeeModalData({
        ...employeeModalData,
        [event.target.name]: event.target.value,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({
          ...employeeModalData,
          [event.target.name]: event.target.value,
        });
    }
  };

  const handleNext = (e) => {
    if (validate(employeeModalData)) {
      if (editRecord?.employee_id) {
        Update();
      } else {
        if (step === 1 && employeeModalData?.create_user) { //Login Access ON
          setStep(2);
        } else if (step === 1 && !employeeModalData?.create_user) { // Login Access Off
          handleSubmit(e)
        }
      }
    }
  };
  const HandleClose = () => {
    if (
      checkPayrollAccess() 
    ) {
      setPayroll(true);
    } else {
      setSuccessPopup(false);
      setOpenPopup(false);
    }
  };
  const handleSubmit = async (e) => {
    if (empno) {
      e.preventDefault();
      if (validate(employeeModalData)) {
        setActionLoader(true);
        let token = uuidv4() + `=${userData?.domain}`;
        let img_filename = "";
        let img_b64string = "";
        let descriptor;
        if (imgfiles?.[0]) {
          img_b64string = await convertBase64(imgfiles?.[0]);
          let ext = imgfiles?.[0]?.name?.split(".").at(-1);
          img_filename =
            `${userData?.domain}/CoreHr/Employee/Profile/` + uuidv4() + "." + ext;
          const resData = await generateEmbeddingsControllerHelper({
            img_b64string: [img_b64string]
          })
          if(resData?.data?.statuscode === 200 && resData?.data?.data?.[0]?.embedding) {
            descriptor = resData?.data?.data?.[0]?.embedding;
          } else {
            toast.error("Face not detected. Please upload again.");
            return;
          }
         
        }
        AddEmployeeHelper({
          ...employeeModalData,
          image: img_filename,
          image_name: img_b64string,
          descriptor: descriptor
            ? descriptor
            : "",
        })
          .then((res) => {
            setActionLoader(false)
            if (res?.data?.statuscode === 200) {
              setCurrentData(res?.data?.data?.[0]);
              setSuccessPopup(true);
              AddEmailTokenHelper({
                token: token,
                email_id: employeeModalData?.office_email,
                json_data: JSON.stringify([{ ...employeeModalData }]),
              });
              if (employeeModalData?.create_user) {
                validateEmailHelper({
                  domain: userData?.domain,
                  email: employeeModalData?.office_email,
                });
              }
              dispatch(GetEmployeesAction({ is_active: !inactive }));
              dispatch(GetHomeAction());
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
    else {
      setWarning(true);
    }

  };
  const Update = async () => {
    if (validate(employeeModalData)) {
      setActionLoader(true);
      let img_filename = "";
      let img_b64string = "";
      let old_image = "";
      let descriptor;
      if (imgfiles?.[0]) {
        img_b64string = await convertBase64(imgfiles?.[0]);
        let ext = imgfiles?.[0]?.name?.split(".").at(-1);
        img_filename =
          `${userData?.domain}/CoreHr/Employee/Profile/` + uuidv4() + "." + ext;

          const resData = await generateEmbeddingsControllerHelper({
            img_b64string: [img_b64string]
          })
          if(resData?.data?.statuscode === 200 && resData?.data?.data?.[0]?.embedding) {
            descriptor = resData?.data?.data?.[0]?.embedding;
          } else {
            toast.error("Face not detected. Please upload again.");
            return;
          }
      
        if (employeeModalData?.image) {
          old_image = employeeModalData?.image;
        }
      } else {
        img_filename = employeeModalData?.image;
        descriptor = employeeModalData?.descriptor;
      }
      UpdateEmployeePopupHelper({
        ...employeeModalData,
        image: img_filename,
        image_name: img_b64string,
        old_image: old_image,
        descriptor: descriptor,
      })
        .then((res) => {
          setActionLoader(false)
          if (res?.data?.statuscode === 200) {
            // editRecord?.office_email  check office_email and emp_users is missing then create user;
            const offEmailPresent = editRecord?.office_email?.trim();
            if (!offEmailPresent && !editRecord?.emp_users) {
              addUserHelper({employee_fk: editRecord?.employee_id,
              office_email: employeeModalData?.office_email, hide: true})
            }
            dispatch(GetEmployeesAction({ is_active: !inactive }));
            dispatch(GetHomeAction());
            setOpenPopup(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
const validatePhotoFile = async (file) => {
  const results = [];
  try {
    if (!file) {
      toast.dismiss();
      toast.error("No file provided");
      return false;
    }

    // basic client-side checks
    if (file.size > 2000000) {
      toast.dismiss();
      toast.error("You can only upload an image with a maximum size of 2 MB.");
      return false;
    }
    if (!["image/png", "image/jpeg"].includes(file.type)) {
      toast.dismiss();
      toast.error("Only .jpeg, .jpg, and .png formats are allowed.");
      return false;
    }

    // ensure face-api models loaded
    await loadFaceApiModels();

    // create image element
    const img = await new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.src = URL.createObjectURL(file);
      image.onload = () => resolve(image);
      image.onerror = (e) => reject(e);
      setTimeout(() => resolve(image), 3000); // fallback safety
    });

    if (!img || !img?.width || !img?.height) {
      toast.dismiss();
      toast.error("Invalid image dimensions");
      return false;
    }

    // face detection using TinyFaceDetector
    const detections = await faceapi
      .detectAllFaces(img, new faceapi.TinyFaceDetectorOptions())
      .withFaceLandmarks();
    if (!detections || detections?.length !== 1 || !detections[0]?.detection?.box) {
       toast.dismiss();
       toast.error("No face detected / Multiple faces present", { autoClose: 5000 });
       return false;
    }

    // exactly one face -> perform checks
    const detection = detections[0];
    const box = detection.detection.box;
    if (typeof box.x !== 'number' || typeof box.y !== 'number' || typeof box.width !== 'number' || typeof box.height !== 'number') {
      toast.dismiss();
      toast.error("Face detection quality is too low. Please upload a clearer photo.", { autoClose: 5000 });
      return false;
    }
    const faceRatio = box?.height / img?.height;
    const closeUpPass = faceRatio >= 0.35 && faceRatio <= 0.8;
    if (!closeUpPass) results.push("Face too far/close");

    // tilt check
    let tiltPass = false;
    const landmarks = detection?.landmarks;
    if (landmarks) {
      const leftEye = landmarks.getLeftEye?.();
      const rightEye = landmarks.getRightEye?.();
      if (leftEye && rightEye && leftEye[0] && rightEye[0]) {
        const eyeTilt = Math.abs(leftEye[0].y - rightEye[0].y);
        tiltPass = eyeTilt <= 10;
      }
    }
    if (!tiltPass) results.push("Tilted face");

    // lighting check
    try {
      const canvas = document.createElement("canvas");
      canvas.width = img?.width;
      canvas.height = img?.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      let sum = 0;
      for (let i = 0; i < pixels.length; i += 4) {
        sum += (pixels[i] + pixels[i + 1] + pixels[i + 2]) / 3;
      }
      const avgBrightness = sum / (pixels.length / 4);
      const lightingPass = avgBrightness >= 60 && avgBrightness <= 200;
      if (!lightingPass) results.push("Bad lighting");
    } catch (e) {
      results.push("Lighting check failed");
    }

    // final validation
    if (results.length > 0) {
      toast.dismiss();
      toast.error(
        results?.join("\n")
      );
      return false;
    }

    toast.dismiss();
    toast.success("Photo validation passed!");
    return true;
  } catch (err) {
    toast.error("Validation error: " + err.message);
    return false;
  }
};

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    maxSize: 2000000,
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
    },
    onDrop: async(acceptedFiles) => {
      setImageValidation(true);
      const isValid = await validatePhotoFile(acceptedFiles[0]);
      setImageValidation(false);
      if (!isValid) {
        return;
      }
      
      setimgFiles(acceptedFiles.map((file) => Object.assign(file)));
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
        setOpenModal(true);
      };
      reader.readAsDataURL(acceptedFiles[0]);
    },
    onDropRejected: () => {
      toast.error("You can only upload image with maximum size of 2 MB.", {
        duration: 2000,
      });
    },
  });
  const img = imgfiles?.map((file) => (
    <img
      style={{ borderRadius: "50%", padding: "2px" }}
      width="100%"
      height="100%"
      key={file.name}
      alt={file.name}
      className="single-file-image"
      src={URL.createObjectURL(file)}
    />
  ));
  const handleDelete = (e) => {
    e.preventDefault();
    setimgFiles([]);
    setImageUrl("");
    setEmployeeModalData((prevData) => ({
      ...prevData,
      image: "", // Setting image to an empty string
    }));
  };

  const handleRotationChange = (event, newValue) => {
    setRotation(newValue);
    if (cropperRef.current?.cropper) {
      cropperRef.current.cropper.rotateTo(newValue);
    }
  };
  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const croppedCanvas = cropper.getCroppedCanvas();
      const fileName = imgfiles?.[0]?.name;
      const fileExtension = fileName?.split(".").pop();

      croppedCanvas.toBlob((blob) => {
        const file = new File([blob], fileName, {
          type: `image/${fileExtension}`,
        });
        setimgFiles([file]);
        setOpenModal(false);
      }, `image/${fileExtension}`);
    }
  };
  const handleNavigate = (menu, value) => {
    setOpenConfirmation(true);
    setWarning(false);

  };
  return (
    <>
      {step === 1 ? (
        <>
          <Grid container>
            <Grid container>
              <Grid item xs={12} md={12} sx={{ px: "0.75rem", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1}}>
                {!editRecord?.employee_id && (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={employeeModalData?.create_user}
                        onChange={handleInputChange}
                        name="create_user"
                        color="primary"
                        disabled={editRecord?.create_user}
                      />
                    }
                    label= {"Enable Login Access"} 
                    labelPlacement="start"
                  />
                )}
                <FormControlLabel
                  control={
                    <Switch
                      checked={employeeModalData?.custom_empno_flag}
                      onChange={handleInputChange}
                      name="custom_empno_flag"
                      color="primary"
                      disabled={editRecord?.custom_empno_flag}
                    />
                  }
                  label= {"Use Custom Employee Number"} 
                  labelPlacement="start"
                />
              </Grid>
              {employeeModalData?.custom_empno_flag && (
                <Grid item xs={12} md={12} sx={{ px: "0.75rem", pb: "6px"}}>
                  <FormControl fullWidth>
                    <TextField
                      size="small"
                      required
                      value={employeeModalData?.custom_empno_value}
                      onChange={handleInputChange}
                      variant="outlined"
                      fullWidth
                      id="custom_empno_value"
                      label="Custom Employee Number"
                      name="custom_empno_value"
                      {...(errors.custom_empno_value && {
                        error: true,
                        helperText: errors.custom_empno_value,
                      })}
                    />
                  </FormControl>
                </Grid>
              )}

              <Grid
                key="first_name"
                item
                xs={12}
                md={12}
                sx={{ padding: "0.75rem", display: "flex", justifyContent: "space-between" }}

              >
                <FormControl size="small" sx={{ width: "30%", mr: 1 }}>
                  <InputLabel id="recruiter-type-select-label">Title</InputLabel>
                  <Select
                    label="Title"
                    name='title'
                    id="title"
                    value={employeeModalData?.title}
                    onChange={(e) => setEmployeeModalData({ ...employeeModalData, title: e.target.value })}
                  >
                    <MenuItem value={"Mr"}>Mr</MenuItem>
                    <MenuItem value={"Mrs"}>Mrs</MenuItem>
                    <MenuItem value={"Ms"}>Ms</MenuItem>
                    <MenuItem value={"Miss"}>Miss</MenuItem>
                    <MenuItem value={"Dr"}>Dr</MenuItem>
                    <MenuItem value={"Mx"}>Mx</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    autoFocus={true}
                    required
                    size="small"
                    value={employeeModalData.first_name}
                    onChange={handleInputChange}
                    variant="outlined"
                    fullWidth
                    onKeyPress={(e) =>
                      e.target.value?.length >= 35 && e.preventDefault()
                    }
                    onPaste={(e) =>
                      e.target.value?.length >= 35 && e.preventDefault()
                    }
                    id="first_name"
                    label="First Name"
                    name="first_name"
                    autoComplete="first_name"
                    {...(errors.first_name && {
                      error: true,
                      helperText: errors.first_name,
                    })}
                  />
                </FormControl>
              </Grid>
              <Grid
                key="last_name"
                item
                xs={12}
                md={12}
                sx={{ padding: "0.75rem" }}
              >
                <FormControl fullWidth>
                  <TextField
                    size="small"
                    required
                    value={employeeModalData.last_name}
                    onChange={handleInputChange}
                    variant="outlined"
                    fullWidth
                    id="last_name"
                    label="Last Name"
                    onKeyPress={(e) =>
                      e.target.value?.length >= 35 && e.preventDefault()
                    }
                    onPaste={(e) =>
                      e.target.value?.length >= 35 && e.preventDefault()
                    }
                    name="last_name"
                    autoComplete="last_name"
                    {...(errors.last_name && {
                      error: true,
                      helperText: errors.last_name,
                    })}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
                <TextField
                  label=" Email"
                  fullWidth
                  name="office_email"
                  required
                  onChange={handleInputChange}
                  value={employeeModalData?.office_email || ""}
                  disabled={editRecord?.employee_id && editRecord?.office_email?.trim() ? true : false}
                  size="small"
                  {...(errors.office_email && {
                    error: true,
                    helperText: errors.office_email,
                  })}
                />
              </Grid>


              <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
                <TextField
                  label="Mobile Number (WhatsApp)"
                  fullWidth
                  name="whatsapp_phone_no"
                  required={whatsAppFlow}
                  onChange={handleInputChange}
                  value={employeeModalData?.whatsapp_phone_no || ""}
                  size="small"
                  {...(errors.whatsapp_phone_no && {
                    error: true,
                    helperText: errors.whatsapp_phone_no,
                  })}
                />
              </Grid>


              <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
                <FormControl fullWidth>
                  <CommonDatePicker
                    size="small"
                    name="dob"
                    label="Birth Date"
                    pickerType="date"
                    onKeyPress={(e) => e.preventDefault()}
                    onKeyDown={(e) => e.preventDefault()}
                    maxDate={new Date().setFullYear(
                      new Date().getFullYear() - 18
                    )}
                    pickerFormat="dd/MM/yyyy"
                    DefaultDTvalue={employeeModalData?.dob}
                    handleChange={(value) =>
                      handleInputChange({
                        target: {
                          name: "dob",
                          value: value
                            ? `${value?.getFullYear() +
                            "-" +
                            ("0" + (value.getMonth() + 1)).slice(-2) +
                            "-" +
                            ("0" + value.getDate()).slice(-2)
                            }`
                            : "",
                        },
                      })
                    }
                    {...(errors.dob && {
                      error: true,
                      helperText: errors.dob,
                    })}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
                <CreatableSearch
                  isOptionEqualToValue={(option, value) =>
                    +option._designation_id === +value._designation_id
                  }
                  label="Designation"
                  value={employeeModalData?._designation_id}
                  loading={() =>
                    setDesignationData({
                      load: false,
                      values: designation_options,
                    })
                  }
                  fieldLabel="name"
                  required={true}
                  variant={"contained"}
                  name="_designation_id"
                  size="small"
                  onChangeEvent={handleInputChange}
                  data={designationData}
                  showAddOption={true}
                  OptionName="Type to add new Designation"
                  {...(errors._designation_id && {
                    error: true,
                    helperText: errors._designation_id,
                  })}
                />
              </Grid>
              <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
                <SelectableSearch
                  isOptionEqualToValue={(option, value) =>
                    +option.ats_work_location_id === +value.ats_work_location_id
                  }
                  label="Work Location"
                  value={employeeModalData?.ats_work_location_id}
                  loading={() =>
                    setWorklocationData({
                      load: false,
                      values: workLocation_options,
                    })
                  }
                  fieldLabel="work_location_name"
                  required={true}
                  variant={"contained"}
                  name="ats_work_location_id"
                  size="small"
                  onChangeEvent={handleInputChange}
                  data={worklocationData}
                  {...(errors.ats_work_location_id && {
                    error: true,
                    helperText: errors.ats_work_location_id,
                  })}
                />
              </Grid>
              <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
                <FormControl fullWidth>
                  <SelectableSearch
                    label="Reporting Manager"
                    value={employeeModalData?.reportingmanager_id}
                    loading={() => handleEmployees()}
                    fieldLabel="name"
                    required={true}
                    variant={"outlined"}
                    name="reportingmanager_id"
                    size="small"
                    onChangeEvent={handleInputChange}
                    data={employeesData}
                    {...(errors.reportingmanager_id && {
                      error: true,
                      helperText: errors.reportingmanager_id,
                    })}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
                <FormControl fullWidth>
                  <SelectableSearch
                    label="Contractor"
                    value={employeeModalData?.contractor_id}
                    loading={() => handleContractorOptionLoad()}
                    fieldLabel="name"
                    variant={"outlined"}
                    name="contractor_id"
                    size="small"
                    onChangeEvent={handleInputChange}
                    data={contractorOptions}
                    endIcon={
                      <Tooltip
                        title="Selecting a contractor will set the employee's Employment Type to Contractual."
                        arrow
                        placement="top"
                      >
                        <InfoOutlinedIcon
                          fontSize="small"
                          sx={{
                            color: "text.secondary",
                            cursor: "help",
                          }}
                        />
                      </Tooltip>
                    }
                    {...(errors.contractor_id && {
                      error: true,
                      helperText: errors.contractor_id,
                    })}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
                <FormControl fullWidth>
                  <CommonDatePicker
                    required
                    size="small"
                    name="joining_date"
                    label="Date of Joining"
                    pickerType="date"
                    onKeyPress={(e) => e.preventDefault()}
                    onKeyDown={(e) => e.preventDefault()}
                    pickerFormat="dd/MM/yyyy"
                    DefaultDTvalue={employeeModalData?.joining_date}
                    handleChange={(value) =>
                      handleInputChange({
                        target: {
                          name: "joining_date",
                          value: value
                            ? `${value?.getFullYear() +
                            "-" +
                            ("0" + (value?.getMonth() + 1)).slice(-2) +
                            "-" +
                            ("0" + value?.getDate()).slice(-2)
                            }`
                            : "",
                        },
                      })
                    }
                    {...(errors.joining_date && {
                      error: true,
                      helperText: errors.joining_date,
                    })}
                  />
                </FormControl>
              </Grid>
              {/* <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
                <FormControl fullWidth>
                  <SelectableSearch
                    label="Working Hour Code"
                    value={employeeModalData?.work_hour_configuration_id}
                    loading={() =>
                      setWorkhrData({
                        load: false,
                        values: work_hours_data,
                      })
                    }
                    fieldLabel="work_hour_code"
                    required={true}
                    variant={"outlined"}
                    name="work_hour_configuration_id"
                    size="small"
                    onChangeEvent={handleInputChange}
                    data={workhrData}
                    {...(errors.work_hour_configuration_id && {
                      error: true,
                      helperText: errors.work_hour_configuration_id,
                    })}
                  />
                </FormControl>
              </Grid> */}
              <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
                <FormControl fullWidth>
                  <SelectableSearch
                    label="Business Unit"
                    value={employeeModalData?.businessUnit}
                    loading={() =>
                      setBusinessUnitData({
                        load: false,
                        values: businessunitData,
                      })
                    }
                    fieldLabel="name"
                    variant={"outlined"}
                    name="businessUnit"
                    size="small"
                    onChangeEvent={handleInputChange}
                    data={businessUnitData}
                    {...(errors.businessUnit && {
                      error: true,
                      helperText: errors.businessUnit,
                    })}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
                <TextField
                  label="Previous Employee ID"
                  fullWidth
                  name="previous_employee_id"
                  onChange={handleInputChange}
                  value={employeeModalData?.previous_employee_id || ""}
                  size="small"
                />
              </Grid>
              {/* {userData?.f_country_code === "IND" && (
                <Grid
                  key="uan_no"
                  item
                  xs={12}
                  md={12}
                  sx={{ padding: "0.75rem" }}
                >
                  <FormControl fullWidth>
                    <TextField
                      size="small"
                      value={employeeModalData.uan_no}
                      onChange={handleInputChange}
                      variant="outlined"
                      fullWidth
                      id="uan_no"
                      label="UAN Number"
                      name="uan_no"
                      placeholder="123456789012"
                      sx={{
                        "& input::placeholder": {
                          color: "#B0B0B0",
                        },
                      }}
                      {...(errors.uan_no && {
                        error: true,
                        helperText: errors.uan_no,
                      })}
                    />
                  </FormControl>
                </Grid>
              )}
              {userData?.f_country_code === "IND" && (
                <Grid
                  key="pan"
                  item
                  xs={12}
                  md={12}
                  sx={{ padding: "0.75rem" }}
                >
                  <FormControl fullWidth>
                    <TextField
                      size="small"
                      value={employeeModalData.pan}
                      onChange={handleInputChange}
                      variant="outlined"
                      fullWidth
                      id="pan"
                      label="PAN Number"
                      name="pan"
                      placeholder="AAAAA9999A"
                      sx={{
                        "& input::placeholder": {
                          color: "#B0B0B0",
                        },
                      }}
                      {...(errors?.pan && {
                        error: true,
                        helperText: errors?.pan,
                      })}
                    />
                  </FormControl>
                </Grid>
              )} */}

              <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
                <Box>
                  <Paper
                    className={classes.paper}
                    sx={{ padding: "80px 24px 40px", borderRadius: "16px" }}
                  >
                    <Box
                      sx={{
                        marginBottom: "5px",
                        border: "none !important",
                        cursor: "default",
                      }}
                      {...getRootProps({ className: "dropzone" })}
                    >
                      <input {...getInputProps()} />
                      <div className="presentation">
                        <div className="placeholder" style={{ position: "relative", width: "100%", height: "100%" }}>
                          {imageValidation && (
                            <div
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "rgba(255, 255, 255, 0.6)", // optional semi-transparent overlay
                                zIndex: 10,
                              }}
                            >
                              <CircularProgress color="action" disableShrink/>
                            </div>
                            )}
                          {imgfiles.length ? (
                            img
                          ) : employeeModalData?.image ? (
                            <img
                              style={{ borderRadius: "50%", padding: "2px" }}
                              alt="Nothing"
                              width="100%"
                              height="100%"
                              src={imageUrl}
                            />
                          ) : (
                            <>
                              <AddPhotoAlternateIcon />
                              <Typography
                                variant="caption"
                                display="block"
                                gutterBottom
                              >
                                Upload Photo
                              </Typography>
                            </>
                          )}
                        </div>
                      </div>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      {(imgfiles?.length > 0 || employeeModalData?.image) && (
                        <Tooltip title="Delete Image">
                          <DeleteIcon
                            sx={{ cursor: "pointer" }}
                            onClick={handleDelete}
                            color="error"
                          />
                        </Tooltip>
                      )}
                    </Box>
                    <Typography
                      sx={{ margin: "5px auto 0px" }}
                      variant="caption"
                      className="content-sec"
                    >
                      File formats allowed *.jpeg, *.jpg, *.png
                      <br /> max size of 2 MB
                    </Typography>
                  </Paper>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mr: 1.5 }}>
            <Button
              className="mpl-primary-btn"
              variant="contained"
              size="medium"
              onClick={handleNext}
              disabled={actionLoader}
              startIcon={actionLoader ? <CircularProgress size={18} color="inherit" /> : null}
            >
              {editRecord?.employee_id ? "Update" : employeeModalData?.create_user ? "Next" : "Submit"}
            </Button>
          </Box>
        </>
      ) : (
        <>
          <Grid container>
            <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
              <FormControl
                required
                fullWidth
                error={errors?.core_hr_user_type ? true : false}
                size="small"
              >
                <InputLabel id="recruiter-type-select-label">
                  User Type
                </InputLabel>
                <Select
                  name="core_hr_user_type"
                  labelId="recruiter-type-select-label"
                  id="recruiter-type-select"
                  value={employeeModalData?.core_hr_user_type}
                  label="User Type"
                  onChange={handleInputChange}
                >
                  <MenuItem value={"Admin"}>Admin</MenuItem>
                  <MenuItem value={"Employee"}>Employee</MenuItem>
                </Select>
                <FormHelperText>{errors?.core_hr_user_type}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
              <FormControl fullWidth>
                <TextField
                  disabled
                  label="Name"
                  name="name"
                  onChange={handleInputChange}
                  value={
                    employeeModalData?.first_name +
                    " " +
                    employeeModalData?.last_name || ""
                  }
                  size="small"
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
              <FormControl fullWidth>
                <TextField
                  disabled
                  label="Email"
                  name="office_email"
                  onChange={handleInputChange}
                  value={employeeModalData?.office_email || ""}
                  size="small"
                />
              </FormControl>
            </Grid>
             {["Employee"].includes(employeeModalData?.core_hr_user_type) && (
              <Grid item xs={12} md={6} sx={{ padding: "0px 0.75rem", height: "45px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      disabled
                      name="enable_corehr"
                      checked={employeeModalData?.enable_corehr || false}
                      onChange={handleInputChange}
                    />
                  }
                  label={
                    <LabelWithInfo
                      label="Enable Core HR"
                    />
                  }
                />
              </Grid>
             )}
             <Grid item xs={12} md={6} sx={{ padding: "0px 0.75rem", height: "45px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      name="enable_employee_management"
                      checked={employeeModalData?.enable_employee_management || false}
                      onChange={handleInputChange}
                    />
                  }
                  label={
                    <LabelWithInfo
                      label="Enable Employee Management"
                      tooltip="Allows the user to access and manage employee-related information."
                    />
                  }
                />
              </Grid>
              {userData?.f_country_code === "IND" && leaveAccess &&(
                <Grid item xs={12} md={6} sx={{ padding: "0px 0.75rem", height: "45px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      name="enable_lms"
                      checked={employeeModalData?.enable_lms || false}
                      onChange={handleInputChange}
                    />
                  }
                  label={
                    <LabelWithInfo
                      label="Enable LMS"
                    />
                  }
                />
              </Grid>)}
            {userData?.f_country_code === "IND" && leaveAccess && employeeModalData?.enable_lms &&
              (<Grid item xs={12} md={6} sx={{ padding: "0px 0.75rem", height: "45px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      name="enable_lms_executive"
                      checked={employeeModalData?.enable_lms_executive || false}
                      onChange={handleInputChange}
                    />
                  }
                  label={
                    <LabelWithInfo
                      label="Enable LMS Executive Access"
                      tooltip="Allows the user to manage leave requests and attendance for employees within their reporting hierarchy."
                    />
                  }
                />
              </Grid>)}

            {userData?.enable_ats && <Grid item xs={12} md={6} sx={{ padding: "0px 0.75rem", height: "45px"}} >
               <FormControlLabel
                 control={
                   <Checkbox
                     size="small"
                     name="enable_ats"
                     checked={employeeModalData?.enable_ats || false}
                     onChange={handleInputChange}
                   />
                 }
                 label={
                    <LabelWithInfo
                      label="Enable ATS"
                    />
                  }
               />
             </Grid>}
              
            {["Admin"].includes(employeeModalData?.core_hr_user_type) && (
                <Grid item xs={12} md={6} sx={{ padding: "0px 0.75rem", height: "45px" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        name="enable_settings_access"
                        checked={employeeModalData?.enable_settings_access || false}
                        onChange={handleInputChange}
                      />
                    }
                    label={
                      <LabelWithInfo
                        label="Enable Settings"
                      />
                    }
                  />
                </Grid>
            )}

            {userData?.workspace_expense_flag && 
               <Grid item xs={12} md={6} sx={{ padding: "0px 0.75rem", height: "45px"}}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        name="enable_expense_executive"
                        checked={employeeModalData?.enable_expense_executive || false}
                        onChange={handleInputChange}
                      />
                    }
                    label={
                      <LabelWithInfo
                        label="Enable Expense Executive Access"
                        tooltip="Enables access to Team Expenses."
                      />
                    }
                  />
                </Grid>
            }
             {userData?.workspace_visitor_management_flag && (
              <Grid container item xs={12}>
                <Grid item xs={12} md={6} sx={{ padding: "0px 0.75rem", height: "45px"}}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        name="enable_visitor_management"
                        checked={employeeModalData?.enable_visitor_management || false}
                        onChange={handleInputChange}
                      />
                    }
                    label={
                      <LabelWithInfo
                        label="Enable Visitor Management"
                        tooltip="Enables access to the core Visitor Management modules, including Pre-registration and Visitor Entry."
                      />
                    }
                  />
                </Grid>
                {employeeModalData?.enable_visitor_management && (
                  <Grid item xs={12} md={6} sx={{ padding: "0px 0.75rem", height: "45px"}}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          name="vm_exec_access"
                          checked={employeeModalData?.vm_exec_access || false}
                          onChange={handleInputChange}
                        />
                      }
                      label={
                        <LabelWithInfo
                          label={"Enable Visitor Executive Access"}
                          tooltip="Enables additional access to Dashboard and Report along with Pre-registration and Visitor Entry."
                        />
                      }
                    />
                  </Grid>)}
              </Grid>
              )}
            { checkPayrollAccess() && <>
              <Grid item xs={12} sx={{ padding: "0px 0.75rem", height: "45px"}}>
                <FormControl
                    error={errors?.enable_payroll && !employeeModalData?.enable_payroll_executive && !employeeModalData?.enable_finance_executive}
                    component="fieldset"
                  >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        name="enable_payroll"
                        checked={employeeModalData?.enable_payroll || false}
                        onChange={handleInputChange}
                      />
                    }
                    label={
                      <LabelWithInfo
                        label="Enable Executive Access for Payroll"
                        tooltip="Enables access to the core Payroll Management modules."
                      />
                    }
                  />
                  {errors?.enable_payroll && !employeeModalData?.enable_payroll_executive && !employeeModalData?.enable_finance_executive && (
                    <FormHelperText>
                      {errors?.enable_payroll}
                    </FormHelperText>
                  )}
                </FormControl>
                </Grid>
                {employeeModalData?.enable_payroll && (
                    <Grid container md={12} alignItems={"center"} sx={{border: "1px solid #e0e0e0", borderRadius: "5px", mt: "-5px"}}>
                      <Grid item xs={12} md={6} sx={{ padding: "2px 0.75rem 0px 0.75rem", height: "45px"}}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              name="enable_payroll_executive"
                              checked={employeeModalData?.enable_payroll_executive || false}
                              onChange={handleInputChange}
                            />
                          }
                          label={
                            <LabelWithInfo
                              label="Assign as Payroll Executive"
                              tooltip="Allows the user to process and manage payroll operations."
                            />
                          }
                        />
                      </Grid>
                      <Grid item xs={12} md={6} sx={{ padding: "2px 0.75rem 0px 0.75rem", height: "45px"}}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              name="enable_finance_executive"
                              checked={employeeModalData?.enable_finance_executive || false}
                              onChange={handleInputChange}
                            />
                          }
                          label={
                            <LabelWithInfo
                              label="Assign as Finance Executive"
                              tooltip="Allows the user to process and manage payroll operations."
                            />
                          }
                        />
                      </Grid>
                    </Grid>
                )}
                </> }
          </Grid>
          <Box
            sx={{ display: "flex", justifyContent: "space-between", mr: 1.5, mt: "20px" }}
          >
            <Button
              className="mpl-primary-btn"
              variant="contained"
              size="medium"
              onClick={() => setStep(1)}
            >
              Back
            </Button>
            <Button
              className="mpl-primary-btn"
              variant="contained"
              size="medium"
              onClick={handleSubmit}
              disabled={actionLoader}
              startIcon={actionLoader ? <CircularProgress size={18} color="inherit" /> : null}
            >
              Submit
            </Button>
          </Box>
        </>
      )}
      <Popup
        openPopup={successPopup}
        setOpenPopup={setSuccessPopup}
        fullWidth={false}
        maxWidth="md"
        close={false}
        hideDividers={true}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
            <img src={Success} alt="Success" width={"15%"} />
          </Box>
          <Typography variant="h6"> Employee Created Successfully. </Typography>
          {employeeModalData?.create_user && <Typography variant="h6">
            {" "}
            Employee Password Setup Instructions have been sent successfully to{" "}
            <span style={{ color: "#883bd5" }}>
              {employeeModalData?.office_email}
            </span>
          </Typography>}
          <Typography variant="h6">
            {" "}
            For any updates on the onboarded employee, please visit My Employee
            Section.{" "}
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "10px",
            }}
          >
            <Button
              onClick={HandleClose}
              variant="contained"
              type="submit"
              className="mpl-primary-btn profile-btn"
              size="small"
              sx={{
                margin: "10px",
              }}
            >
              Ok
            </Button>
          </Box>
        </Box>
      </Popup>
      <PayrollSetupPopup
        emp={true}
        payroll={payroll}
        setPayroll={setPayroll}
        currentData={currentData}
        setSuccessPopup={setSuccessPopup}
        setOpenPopup={setOpenPopup}
      />
      {/* Modal for Cropping Image */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: 1,
            p: 4,
            boxShadow: 24,
            maxWidth: 500,
            width: "100%",
            textAlign: "center",
          }}
        >
          <IconButton
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
            }}
            onClick={() => setOpenModal(false)}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6">Crop Profile Image</Typography>
          {image && (
            <Box sx={{ marginTop: 2 }}>
              <Cropper
                ref={cropperRef}
                src={image}
                style={{
                  height: 300,
                  width: "100%",
                }}
                initialAspectRatio={1}
                aspectRatio={1}
                guides={false}
                movable={true}
                zoomable={true}
                scalable={true}
                cropBoxResizable={false}
                cropBoxMovable={true}
                minCropBoxWidth={200}
                minCropBoxHeight={200}
                background={true}
              />

              <Box sx={{ marginTop: 2 }}>
                <Typography variant="body1">Rotate Image</Typography>
                <Slider
                  value={rotation}
                  min={-180}
                  max={180}
                  step={1}
                  onChange={handleRotationChange}
                  valueLabelDisplay="auto"
                  valueLabelFormat={(value) => `${value}°`}
                />
              </Box>
              <Button
                onClick={handleCrop}
                className="mpl-primary-btn"
                variant="contained"
                size="medium"
              >
                Crop Image
              </Button>
            </Box>
          )}
        </Box>
      </Modal>
      <Popup
        maxWidth="sm"
        openPopup={warning}
        setOpenPopup={setWarning}
        title="Note!"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
            <img src={Note} width={"25%"} alt="note_img" />
          </Box>
          <FormControl>
            <FormLabel id="gender-label">
              <Typography variant="h5">
                Employee No Configuration is incomplete. Please navigate to
                Settings &gt; General &gt; Organization &gt; Employee ID
                Configuration
              </Typography>
            </FormLabel>
          </FormControl>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "10px",
          }}
        >
          <Button
            onClick={() => handleNavigate("General", "4")}
            variant="contained"
            type="submit"
            className="mpl-primary-btn profile-btn"
            size="small"
            sx={{
              margin: "10px",
            }}
          >
            Click Here
          </Button>
        </Box>
      </Popup>
      <Popup
        title={"Employee ID Configuration"}
        openPopup={openConfirmation}
        setOpenPopup={setOpenConfirmation}
        maxWidth="md"
        fullWidth={true}
      >
        <EmployeeID validateOnly={true} setOpenConfirmation={() => {setOpenConfirmation(false); EmployeeIdConfigCheck();}}/>
      </Popup>
    </>
  );
};


const LabelWithInfo = ({ label, tooltip }) => (
  <Typography
    variant="body1"
    color="inherit"
    sx={{
      fontSize: 13,
      display: "flex",
      alignItems: "center",
      gap: 0.5,
    }}
  >
    {label}

    {tooltip && (
      <Tooltip title={tooltip} arrow placement="top">
        <InfoOutlinedIcon
          color="action"
          sx={{
            cursor: "pointer",
            fontSize: 16,
          }}
        />
      </Tooltip>
    )}
  </Typography>
);
export default AddEmployeePopup;
